import { serviceDetails } from "./services-data"

// Service Types
export const serviceTypes =serviceDetails.map(service=>(
  {
    value:service.slug,
    label:service.title
  }
))

// Budget Ranges
export const budgetRanges = [
  { value: "under-10k", label: "Under ₹10,000" },
  { value: "10k-25k", label: "₹10,000 - ₹25,000" },
  { value: "25k-50k", label: "₹25,000 - ₹50,000" },
  { value: "50k-100k", label: "₹50,000 - ₹1,00,000" },
  { value: "100k-200k", label: "₹1,00,000 - ₹2,00,000" },
  { value: "200k-above", label: "₹2,00,000+" }
]

// House Types
export const houseTypes = [
  { value: "1bhk", label: "1 BHK" },
  { value: "2bhk", label: "2 BHK" },
  { value: "3bhk", label: "3 BHK" },
  { value: "4bhk", label: "4 BHK" },
  { value: "villa", label: "Villa/Independent House" },
  { value: "studio", label: "Studio Apartment" },
  { value: "penthouse", label: "Penthouse" },
  { value: "other", label: "Other" }
]

// Floor Types
export const floorTypes = [
  { value: "ground", label: "Ground Floor" },
  { value: "1st", label: "1st Floor" },
  { value: "2nd", label: "2nd Floor" },
  { value: "3rd", label: "3rd Floor" },
  { value: "4th", label: "4th Floor" },
  { value: "5th", label: "5th Floor" },
  { value: "above-5th", label: "Above 5th Floor" }
]

// Packing Materials
export const packingMaterials = [
  { value: "standard", label: "Standard Packing" },
  { value: "premium", label: "Premium Packing" },
  { value: "eco-friendly", label: "Eco-Friendly Materials" },
  { value: "custom", label: "Custom Packing" }
]

// Vehicle Types for Transportation
export const vehicleTypes = [
  { value: "car", label: "Car" },
  { value: "bike", label: "Motorcycle/Scooter" },
  { value: "truck", label: "Truck" },
  { value: "bus", label: "Bus" },
  { value: "other", label: "Other Vehicle" }
]

// Time Preferences
export const timePreferences = [
  { value: "morning", label: "Morning (8 AM - 12 PM)" },
  { value: "afternoon", label: "Afternoon (12 PM - 4 PM)" },
  { value: "evening", label: "Evening (4 PM - 8 PM)" },
  { value: "flexible", label: "Flexible" }
]

// Insurance Options
export const insuranceOptions = [
  { value: "basic", label: "Basic Coverage (₹1,000 per kg)" },
  { value: "standard", label: "Standard Coverage (₹2,000 per kg)" },
  { value: "premium", label: "Premium Coverage (₹5,000 per kg)" },
  { value: "comprehensive", label: "Comprehensive Coverage" },
  { value: "none", label: "No Insurance" }
]

// Priority Levels
export const priorityLevels = [
  { value: "low", label: "Low Priority" },
  { value: "normal", label: "Normal Priority" },
  { value: "high", label: "High Priority" },
  { value: "urgent", label: "Urgent" }
]

// Contact Preferences
export const contactPreferences = [
  { value: "phone", label: "Phone Call" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "Email" },
  { value: "sms", label: "SMS" }
]

// Helper functions
export const getOptionByValue = (options: Array<{value: string, label: string}>, value: string) => {
  return options.find(option => option.value === value)
}